// apex-quiz.js
// Apexzen Persona Quiz - State machine + submission + tracking
// Version 1.0.0 - 2026-05-22
// ASCII/cp1252 - no emoji - no jQuery
// Anti-boucle : 1 submission max par session (localStorage flag)

(function () {
  'use strict';

  // ============================================================
  // CONFIG
  // ============================================================

  var QUIZ_CONFIG_URL = window.Shopify
    ? window.Shopify.routes.root + 'cdn/shop/files/apex-quiz-config.json'
    : '/assets/apex-quiz-config.json';
  var STORAGE_KEY_STATE = 'apx_quiz_state_v1';
  var STORAGE_KEY_SUBMITTED = 'apx_quiz_submitted_v1';
  var MAX_RETRIES = 2;
  var SUBMIT_TIMEOUT_MS = 10000;
  var OPTION_ADVANCE_DELAY_MS = 260;

  var PILLAR_COLORS = {
    stress: '#1A4A90',
    sleep: '#1A2E55',
    perf: '#B07F3A',
    focus: '#3D70B0',
    cardio: '#B82E20',
    'default': '#1A4A90'
  };

  // ============================================================
  // STATE
  // ============================================================

  var state = {
    currentStep: 1,
    totalSteps: 8,
    answers: {},
    scores: { marcus: 0, jessica: 0, david: 0, sarah: 0, waitlist_prenat: 0 },
    chronotype: null,
    personaId: null,
    email: null,
    retryCount: 0,
    config: null,
    webhookUrl: '',
    startedAt: Date.now()
  };

  // ============================================================
  // DOM REFERENCES
  // ============================================================

  var elFlow = document.getElementById('apx-quiz-flow');
  var elQuestions = document.getElementById('apx-quiz-questions');
  var elGate = document.getElementById('apx-quiz-gate');
  var elResultWrap = document.getElementById('apx-quiz-result-wrap');
  var elError = document.getElementById('apx-quiz-error');
  var elErrorMsg = document.getElementById('apx-quiz-error-msg');
  var elRetryBtn = document.getElementById('apx-quiz-retry-btn');
  var elProgressBar = document.getElementById('apx-quiz-progress-bar');
  var elProgressLabel = document.getElementById('apx-quiz-progress-label');
  var elGateForm = document.getElementById('apx-quiz-gate-form');
  var elEmailInput = document.getElementById('apx-quiz-email-input');
  var elEmailError = document.getElementById('apx-quiz-email-error');
  var elGateSubmit = document.getElementById('apx-quiz-gate-submit');

  // ============================================================
  // INIT
  // ============================================================

  function init() {
    if (!elFlow) return;

    state.webhookUrl = elFlow.dataset.webhook || '';

    // Anti-boucle : si deja soumis cette session, afficher resultat cached
    var submitted = safeLocalStorageGet(STORAGE_KEY_SUBMITTED);
    if (submitted && submitted.persona_id) {
      renderResult(submitted.persona_id, submitted.chronotype || null, submitted.email || '');
      return;
    }

    // Charger config JSON quiz
    fetchConfig(function (config) {
      state.config = config;
      // Tenter reprise depuis localStorage
      var saved = safeLocalStorageGet(STORAGE_KEY_STATE);
      if (saved && saved.currentStep && saved.answers) {
        state.currentStep = saved.currentStep;
        state.answers = saved.answers;
        state.scores = saved.scores || state.scores;
        state.chronotype = saved.chronotype || null;
      }
      renderStep(state.currentStep);
    });

    if (elRetryBtn) {
      elRetryBtn.addEventListener('click', function () {
        hideError();
        state.retryCount = 0;
        submitQuiz(state.email, true);
      });
    }

    if (elGateForm) {
      elGateForm.addEventListener('submit', handleGateSubmit);
    }
  }

  // ============================================================
  // CONFIG FETCH
  // ============================================================

  function fetchConfig(callback) {
    var url = '/assets/apex-quiz-config.json';
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.timeout = 5000;
    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          callback(JSON.parse(xhr.responseText));
        } catch (e) {
          callback(getInlineFallbackConfig());
        }
      } else {
        callback(getInlineFallbackConfig());
      }
    };
    xhr.onerror = function () { callback(getInlineFallbackConfig()); };
    xhr.ontimeout = function () { callback(getInlineFallbackConfig()); };
    xhr.send();
  }

  // ============================================================
  // RENDER STEP
  // ============================================================

  function renderStep(stepIndex) {
    updateProgress(stepIndex);

    if (stepIndex >= state.totalSteps) {
      showGate();
      return;
    }

    var questionIndex = stepIndex - 1;
    if (!state.config || !state.config.questions || !state.config.questions[questionIndex]) {
      return;
    }

    renderQuestion(state.config.questions[questionIndex], stepIndex);
  }

  function renderQuestion(q, stepIndex) {
    showQuestions();

    var elStepLabel = document.getElementById('apx-q-step-label');
    var elLabel = document.getElementById('apx-q-label');
    var elSublabel = document.getElementById('apx-q-sublabel');
    var elOptions = document.getElementById('apx-q-options');
    var elSlot = document.getElementById('apx-quiz-question-slot');

    if (!elLabel || !elOptions) return;

    if (elStepLabel) elStepLabel.textContent = 'Question ' + stepIndex + ' of 7';
    elLabel.textContent = q.label || '';
    if (elSublabel) elSublabel.textContent = q.sublabel || '';
    if (elSlot) elSlot.setAttribute('data-step', stepIndex);

    // Pillar color progression
    var pillarKey = stepToPillar(stepIndex);
    // Q6: utilise le pilier de l'option selectionnee si disponible
    if (q.id === 'q6' && state.answers['q6']) {
      var matchOpt = findOption(q.options, state.answers['q6']);
      if (matchOpt && matchOpt.pillar) pillarKey = matchOpt.pillar;
    }
    setPillarColor(pillarKey);

    // Render options
    elOptions.innerHTML = '';
    (q.options || []).forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'apx-quiz-option' + (state.answers[q.id] === opt.id ? ' apx-quiz-option--selected' : '');
      btn.setAttribute('data-option-id', opt.id);
      btn.setAttribute('data-question-id', q.id);
      btn.textContent = opt.label;
      btn.addEventListener('click', function () { handleOptionSelect(q, opt); });
      elOptions.appendChild(btn);
    });

    // Fade in animation
    elOptions.classList.remove('apx-quiz-fade-in');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        elOptions.classList.add('apx-quiz-fade-in');
      });
    });

    // Tracking
    trackEvent('quiz_question_viewed', { step: stepIndex, question_id: q.id });
  }

  function stepToPillar(step) {
    if (step <= 2) return 'stress';
    if (step <= 4) return 'sleep';
    if (step <= 6) return 'focus';
    return 'perf';
  }

  function findOption(options, optionId) {
    if (!options) return null;
    for (var i = 0; i < options.length; i++) {
      if (options[i].id === optionId) return options[i];
    }
    return null;
  }

  // ============================================================
  // OPTION SELECT
  // ============================================================

  function handleOptionSelect(q, opt) {
    // Enregistrer reponse
    state.answers[q.id] = opt.id;

    // Accumuler scores
    if (opt.weight && typeof opt.weight === 'object') {
      Object.keys(opt.weight).forEach(function (key) {
        if (typeof state.scores[key] === 'number') {
          state.scores[key] += (typeof opt.weight[key] === 'number' ? opt.weight[key] : 0);
        }
      });
    }

    // Chronotype si Q4
    if (q.id === 'q4' && opt.chronotype) {
      state.chronotype = opt.chronotype;
    }

    // Force path Q2 pregnant : skip Q3-Q7, aller directement au gate
    if (q.id === 'q2' && opt.id === 'pregnant') {
      state.scores.waitlist_prenat = 99;
      state.personaId = 'waitlist_prenat';
      state.currentStep = state.totalSteps;
      saveState();
      // Visual feedback puis transition
      markSelected(opt.id);
      setTimeout(function () { renderStep(state.currentStep); }, OPTION_ADVANCE_DELAY_MS);
      return;
    }

    // Avancer a la question suivante
    state.currentStep++;
    saveState();

    markSelected(opt.id);

    // Tracking
    trackEvent('quiz_question_answered', { step: state.currentStep - 1, question_id: q.id, option_id: opt.id });

    setTimeout(function () {
      renderStep(state.currentStep);
    }, OPTION_ADVANCE_DELAY_MS);
  }

  function markSelected(optionId) {
    var opts = document.querySelectorAll('.apx-quiz-option');
    for (var i = 0; i < opts.length; i++) {
      opts[i].classList.remove('apx-quiz-option--selected');
      if (opts[i].getAttribute('data-option-id') === optionId) {
        opts[i].classList.add('apx-quiz-option--selected');
      }
    }
  }

  // ============================================================
  // EMAIL GATE
  // ============================================================

  function showGate() {
    if (elQuestions) elQuestions.hidden = true;
    if (elGate) elGate.hidden = false;
    updateProgress(8);
    setPillarColor('perf');
    if (elEmailInput) {
      setTimeout(function () { elEmailInput.focus(); }, 120);
    }
    trackEvent('quiz_gate_viewed', {});
  }

  function handleGateSubmit(e) {
    e.preventDefault();

    // Honeypot check
    var hp = elGateForm ? elGateForm.querySelector('input[name="website"]') : null;
    if (hp && hp.value && hp.value.length > 0) {
      // Bot detected - silent fake success
      showResultFakeSuccess();
      return;
    }

    var email = elEmailInput ? elEmailInput.value.trim() : '';
    if (!validateEmail(email)) {
      showEmailError('Please enter a valid email address.');
      return;
    }
    hideEmailError();

    var consentEl = document.getElementById('apx-quiz-consent-marketing');
    var consent = consentEl ? consentEl.checked : true;

    state.email = email;
    if (!state.personaId) {
      state.personaId = resolvePersona();
    }

    // Anti-boucle : verifier flag avant tout
    var submitted = safeLocalStorageGet(STORAGE_KEY_SUBMITTED);
    if (submitted && submitted.email === email) {
      renderResult(submitted.persona_id, submitted.chronotype, email);
      return;
    }

    setGateLoading(true);
    submitQuiz(email, consent);
  }

  // ============================================================
  // PERSONA RESOLUTION
  // ============================================================

  function resolvePersona() {
    var s = state.scores;

    if (s.waitlist_prenat >= 5) return 'waitlist_prenat';
    if (s.marcus >= 7) return 'marcus';
    if (s.sarah >= 5) return 'sarah';
    // Default V1 = marcus (DTC-first, seul path actif V1)
    return 'marcus';
  }

  // ============================================================
  // SUBMISSION
  // ============================================================

  function submitQuiz(email, consentMarketing) {
    if (typeof consentMarketing === 'undefined') consentMarketing = true;

    var webhookUrl = state.webhookUrl;
    if (!webhookUrl) {
      showError('Configuration error. Please contact support.');
      return;
    }

    var timeSpent = Math.round((Date.now() - state.startedAt) / 1000);

    var payload = {
      email: email,
      first_name: '',
      persona_routing_id: state.personaId || 'marcus',
      quiz_answers: state.answers,
      result_chronotype: state.chronotype || 'ours',
      result_bundle_slug: getBundleSlug(state.personaId, state.chronotype),
      result_score: state.scores,
      time_spent_seconds: timeSpent,
      device: getDevice(),
      utm_source: getUrlParam('utm_source'),
      utm_campaign: getUrlParam('utm_campaign'),
      lang: document.documentElement.lang || 'en',
      consent_marketing: consentMarketing
    };

    var timeoutId = null;
    var xhr = new XMLHttpRequest();

    timeoutId = setTimeout(function () {
      xhr.abort();
      handleSubmitError('timeout');
    }, SUBMIT_TIMEOUT_MS);

    xhr.open('POST', webhookUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onload = function () {
      clearTimeout(timeoutId);
      if (xhr.status >= 200 && xhr.status < 300) {
        // Sauvegarder flag anti-boucle
        safeLocalStorageSet(STORAGE_KEY_SUBMITTED, {
          email: email,
          persona_id: state.personaId,
          chronotype: state.chronotype,
          ts: Date.now()
        });
        // Nettoyer state de progression
        safeLocalStorageSet(STORAGE_KEY_STATE, null);
        // Tracking
        trackEvent('quiz_completed', {
          persona_id: state.personaId,
          chronotype: state.chronotype,
          time_spent_seconds: timeSpent
        });
        setGateLoading(false);
        renderResult(state.personaId, state.chronotype, email);
      } else {
        handleSubmitError('http_' + xhr.status);
      }
    };

    xhr.onerror = function () {
      clearTimeout(timeoutId);
      handleSubmitError('network_error');
    };

    xhr.send(JSON.stringify(payload));
  }

  function handleSubmitError(reason) {
    setGateLoading(false);
    state.retryCount++;
    if (state.retryCount <= MAX_RETRIES) {
      var delay = state.retryCount === 1 ? 1000 : 3000;
      setTimeout(function () {
        setGateLoading(true);
        submitQuiz(state.email, true);
      }, delay);
    } else {
      showError('We could not process your request. Please try again in a moment.');
    }
  }

  // ============================================================
  // RESULT RENDER
  // ============================================================

  function renderResult(personaId, chronotype, email) {
    if (elGate) elGate.hidden = true;
    if (elQuestions) elQuestions.hidden = true;
    if (elResultWrap) elResultWrap.hidden = false;

    updateProgress(8, true);

    var elMarcus = document.getElementById('apx-result-marcus');
    var elWaitlist = document.getElementById('apx-result-waitlist');

    if (personaId === 'marcus') {
      if (elMarcus) {
        elMarcus.hidden = false;
        renderMarcusResult(chronotype || 'ours');
      }
      if (elWaitlist) elWaitlist.hidden = true;
    } else {
      if (elWaitlist) {
        elWaitlist.hidden = false;
        var emailLine = document.getElementById('apx-result-waitlist-email');
        if (emailLine) emailLine.textContent = 'Confirmation sent to ' + email + '.';
      }
      if (elMarcus) elMarcus.hidden = true;
    }

    trackEvent('quiz_result_viewed', { persona_id: personaId, chronotype: chronotype });
  }

  function renderMarcusResult(chronotype) {
    var elChronotypeLine = document.getElementById('apx-result-chronotype-line');
    var elStacks = document.getElementById('apx-result-stacks');

    var chronotypeLabels = {
      lion: 'Lion chronotype: early riser, peak before 10am.',
      ours: 'Bear chronotype: peak mid-morning, standard recovery window.',
      loup: 'Wolf chronotype: late-peak, extended recovery needs.',
      dauphin: 'Dolphin chronotype: fragmented sleep, high cortisol baseline.'
    };

    if (elChronotypeLine) {
      elChronotypeLine.textContent = chronotypeLabels[chronotype] || chronotypeLabels['ours'];
    }

    var bundles = {
      lion: [
        { slug: 'lion-summit-stack', label: 'LION Summit Stack', price: '$74.90' },
        { slug: 'apex-performance-stack', label: 'APEX Performance Stack', price: '$79.90' },
        { slug: 'apex-edge-stack', label: 'APEX EDGE Stack', price: '$94.90' }
      ],
      ours: [
        { slug: 'ours-foundation-daily', label: 'OURS Foundation Daily', price: '$79.90' },
        { slug: 'apex-performance-stack', label: 'APEX Performance Stack', price: '$79.90' },
        { slug: 'apex-edge-stack', label: 'APEX EDGE Stack', price: '$94.90' }
      ],
      loup: [
        { slug: 'loup-night-edge', label: 'LOUP Night Edge', price: '$84.90' },
        { slug: 'apex-performance-stack', label: 'APEX Performance Stack', price: '$79.90' },
        { slug: 'apex-edge-stack', label: 'APEX EDGE Stack', price: '$94.90' }
      ],
      dauphin: [
        { slug: 'dauphin-reset-protocol', label: 'DAUPHIN Reset Protocol', price: '$119.90' },
        { slug: 'apex-performance-stack', label: 'APEX Performance Stack', price: '$79.90' },
        { slug: 'apex-edge-stack', label: 'APEX EDGE Stack', price: '$94.90' }
      ]
    };

    var list = bundles[chronotype] || bundles['ours'];

    if (elStacks) {
      elStacks.innerHTML = '';
      list.forEach(function (b) {
        var card = document.createElement('div');
        card.className = 'apx-quiz-bundle-card';
        var labelEl = document.createElement('p');
        labelEl.className = 'apx-eyebrow apx-quiz-bundle-card__label';
        labelEl.textContent = b.label;
        var priceEl = document.createElement('p');
        priceEl.className = 'apx-h3 apx-quiz-bundle-card__price';
        priceEl.textContent = b.price;
        var ctaEl = document.createElement('a');
        ctaEl.className = 'apx-quiz-bundle-card__cta';
        ctaEl.href = '/products/' + b.slug;
        ctaEl.textContent = 'Get this stack';
        card.appendChild(labelEl);
        card.appendChild(priceEl);
        card.appendChild(ctaEl);
        elStacks.appendChild(card);
      });
    }
  }

  // ============================================================
  // PROGRESS
  // ============================================================

  function updateProgress(step, complete) {
    var pct = complete ? 100 : Math.round((step / state.totalSteps) * 100);
    if (elProgressBar) {
      elProgressBar.style.width = pct + '%';
    }
    var progressWrap = elProgressBar && elProgressBar.closest('[role="progressbar"]');
    if (progressWrap) progressWrap.setAttribute('aria-valuenow', pct);

    if (elProgressLabel) {
      if (complete) {
        elProgressLabel.textContent = 'Protocol ready';
      } else if (step >= state.totalSteps) {
        elProgressLabel.textContent = 'Step 8 of 8 - Final step';
      } else {
        elProgressLabel.textContent = 'Step ' + step + ' of 8';
      }
    }
  }

  // ============================================================
  // PILLAR COLOR
  // ============================================================

  function setPillarColor(pillarKey) {
    var color = PILLAR_COLORS[pillarKey] || PILLAR_COLORS['default'];
    document.documentElement.style.setProperty('--apx-quiz-pillar', color);
  }

  // ============================================================
  // TRACKING
  // ============================================================

  function trackEvent(eventName, params) {
    var p = params || {};
    // Meta Pixel
    if (typeof window.fbq === 'function') {
      try { window.fbq('trackCustom', eventName, p); } catch (e) {}
    }
    // GA4
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', eventName, p); } catch (e) {}
    }
    // Shopify analytics
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish(eventName, p); } catch (e) {}
    }
  }

  // ============================================================
  // UI HELPERS
  // ============================================================

  function showQuestions() {
    if (elQuestions) elQuestions.hidden = false;
    if (elGate) elGate.hidden = true;
  }

  function showEmailError(msg) {
    if (elEmailError) {
      elEmailError.textContent = msg;
      elEmailError.hidden = false;
    }
    if (elEmailInput) {
      elEmailInput.setAttribute('aria-invalid', 'true');
      elEmailInput.classList.add('apx-quiz-gate__input--error');
    }
  }

  function hideEmailError() {
    if (elEmailError) elEmailError.hidden = true;
    if (elEmailInput) {
      elEmailInput.removeAttribute('aria-invalid');
      elEmailInput.classList.remove('apx-quiz-gate__input--error');
    }
  }

  function showError(msg) {
    if (elError) elError.hidden = false;
    if (elErrorMsg) elErrorMsg.textContent = msg || 'Something went wrong. Please try again.';
    if (elGate) elGate.hidden = true;
  }

  function hideError() {
    if (elError) elError.hidden = true;
    if (elGate) elGate.hidden = false;
  }

  function setGateLoading(loading) {
    if (!elGateSubmit) return;
    var labelEl = elGateSubmit.querySelector('.apx-quiz-gate__submit-label');
    var spinnerEl = elGateSubmit.querySelector('.apx-quiz-gate__submit-spinner');
    if (loading) {
      elGateSubmit.disabled = true;
      if (labelEl) labelEl.textContent = 'Sending...';
      if (spinnerEl) spinnerEl.hidden = false;
    } else {
      elGateSubmit.disabled = false;
      if (labelEl) labelEl.textContent = 'Send my protocol';
      if (spinnerEl) spinnerEl.hidden = true;
    }
  }

  function showResultFakeSuccess() {
    if (elGate) elGate.hidden = true;
    if (elResultWrap) elResultWrap.hidden = false;
    var elWaitlist = document.getElementById('apx-result-waitlist');
    if (elWaitlist) elWaitlist.hidden = false;
  }

  // ============================================================
  // UTILITIES
  // ============================================================

  function validateEmail(email) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
  }

  function getUrlParam(name) {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function getDevice() {
    var w = window.innerWidth;
    if (w < 768) return 'mobile';
    if (w < 1024) return 'tablet';
    return 'desktop';
  }

  function getBundleSlug(personaId, chronotype) {
    if (personaId !== 'marcus' || !chronotype) return '';
    var map = { lion: 'lion-summit-stack', ours: 'ours-foundation-daily', loup: 'loup-night-edge', dauphin: 'dauphin-reset-protocol' };
    return map[chronotype] || '';
  }

  function saveState() {
    safeLocalStorageSet(STORAGE_KEY_STATE, {
      currentStep: state.currentStep,
      answers: state.answers,
      scores: state.scores,
      chronotype: state.chronotype
    });
  }

  function safeLocalStorageGet(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function safeLocalStorageSet(key, value) {
    try {
      if (value === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(value));
      }
    } catch (e) {}
  }

  // ============================================================
  // FALLBACK CONFIG (si apex-quiz-config.json inaccessible)
  // ============================================================

  function getInlineFallbackConfig() {
    return {
      quiz_id: 'apexzen-persona-v1',
      email_gate_step: 8,
      questions: [
        {
          id: 'q1',
          label: 'What best describes your role right now?',
          sublabel: 'We calibrate the protocol to your actual output demands.',
          options: [
            { id: 'vp_director', label: 'VP, Director, or C-suite at a scaleup (50+ people)', weight: { marcus: 3 } },
            { id: 'founder_ceo', label: 'Founder or CEO running my own company', weight: { marcus: 1, jessica: 3 } },
            { id: 'senior_ic', label: 'Senior individual contributor or staff engineer', weight: { marcus: 2 } },
            { id: 'pre50_longevity', label: 'Pre-50, focused on longevity - no employer role', weight: { david: 3 } }
          ]
        },
        {
          id: 'q2',
          label: 'Are you currently pregnant or breastfeeding?',
          sublabel: 'Some adaptogens and nootropics are contraindicated. We need to know.',
          options: [
            { id: 'no', label: 'No', weight: { continue: 1 } },
            { id: 'postpartum', label: 'Postpartum or breastfeeding', weight: { sarah: 3 } },
            { id: 'pregnant', label: 'Currently pregnant', weight: { waitlist_prenat: 5 } }
          ]
        },
        {
          id: 'q3',
          label: 'Do you track sleep or HRV with a wearable?',
          sublabel: 'Helps us calibrate recovery recommendations.',
          options: [
            { id: 'yes_oura_whoop', label: 'Yes - Oura, Whoop, or similar', weight: { marcus: 2, david: 2, jessica: 1 } },
            { id: 'yes_apple', label: 'Yes - Apple Watch or Fitbit', weight: { marcus: 1, jessica: 1, david: 1 } },
            { id: 'no_wearable', label: 'No wearable', weight: {} }
          ]
        },
        {
          id: 'q4',
          label: 'How does your typical work day run?',
          sublabel: 'Chronotype alignment is the foundation of the protocol.',
          options: [
            { id: 'early_riser', label: 'Up by 5:30-6am, peak focus before 10am', chronotype: 'lion', weight: { marcus: 2, jessica: 2, david: 1 } },
            { id: 'standard', label: 'Up by 7-8am, peak focus mid-morning', chronotype: 'ours', weight: { marcus: 2, jessica: 1, david: 2 } },
            { id: 'late_peak', label: 'Slow start, peak focus after 2pm', chronotype: 'loup', weight: { marcus: 1, jessica: 2, david: 1 } },
            { id: 'fragmented', label: 'Fragmented - calls, travel, time zones', chronotype: 'dauphin', weight: { marcus: 3, jessica: 1 } }
          ]
        },
        {
          id: 'q5',
          label: 'Do you have children under 5 at home?',
          sublabel: 'Affects sleep architecture and cortisol recovery baseline.',
          options: [
            { id: 'yes_under5', label: 'Yes', weight: { marcus: 1, sarah: 1 } },
            { id: 'no_under5', label: 'No', weight: {} }
          ]
        },
        {
          id: 'q6',
          label: 'What is your primary performance goal right now?',
          sublabel: 'We weight the stack toward your stated priority.',
          options: [
            { id: 'stress_recovery', label: 'Reduce stress and recover faster', pillar: 'stress', weight: { marcus: 2, sarah: 2, jessica: 1 } },
            { id: 'sleep_quality', label: 'Improve sleep quality and onset', pillar: 'sleep', weight: { marcus: 2, david: 2, jessica: 1 } },
            { id: 'focus_energy', label: 'Sustain focus and cognitive energy', pillar: 'focus', weight: { marcus: 3, jessica: 3, david: 1 } },
            { id: 'longevity_base', label: 'Build a longevity baseline (cardiovascular, hormonal)', pillar: 'cardio', weight: { david: 3, marcus: 1 } }
          ]
        },
        {
          id: 'q7',
          label: 'Annual household income - roughly?',
          sublabel: 'Helps us size the protocol recommendation honestly.',
          options: [
            { id: 'under_80k', label: 'Under $80k', weight: { david: 1 } },
            { id: '80k_150k', label: '$80k - $150k', weight: { marcus: 1, jessica: 1, david: 2 } },
            { id: '150k_300k', label: '$150k - $300k', weight: { marcus: 2, jessica: 3, david: 1 } },
            { id: 'above_300k', label: '$300k+', weight: { marcus: 3, jessica: 2, david: 1 } }
          ]
        }
      ]
    };
  }

  // ============================================================
  // BOOT
  // ============================================================

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
